import React from "react";
import { XCircle } from "lucide-react";
import { appealProblems } from "../../data/homepageData";

export const WhyAppealsFail = () => (
  <section className="py-20 bg-gradient-to-b from-slate-900/50 to-transparent">
    <div className="mx-auto max-w-7xl px-6">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold">
          Why Most Appeals
          <span className="text-red-400"> Fail</span>
        </h2>
        <p className="mt-4 text-slate-400 max-w-2xl mx-auto">
          Platforms receive millions of appeals. Most get rejected because of these common mistakes.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {appealProblems.map((problem) => (
          <div
            key={problem.id}
            className="rounded-2xl border border-red-500/20 bg-red-500/5 p-6 hover:border-red-500/40 transition"
          >
            <div className="w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center mb-4">
              <XCircle className="w-5 h-5 text-red-400" />
            </div>
            <h3 className="font-semibold text-lg mb-2">{problem.title}</h3>
            <p className="text-slate-400 text-sm leading-relaxed">{problem.description}</p>
          </div>
        ))}
      </div>

      <div className="mt-12 text-center">
        <p className="text-slate-300 text-lg">
          <span className="text-green-400 font-semibold">We fix these problems</span> by organizing your evidence,
          addressing the specific violation, and submitting through proper channels.
        </p>
      </div>
    </div>
  </section>
);
